import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import ListadoBuquesCalendario from './ListadoBuquesCalendario'
import moment from 'moment'
import { obtenerEstimacionSemanal } from '../../../Stock/actions/listados'

function DetalleBuquesPorDia (props) {
  const { cargasAnunciadas, fechaFiltro, cerealFiltro, obtenerEstimacionSemanal } = props
  const [buquesFiltrados, setBuquesFiltrados] = useState([])

  useEffect(() => {
    if (typeof fechaFiltro === 'string' && fechaFiltro.includes('/')) {
      const dateString = moment(fechaFiltro, 'DD/MM/YYYY').format('YYYY-MM-DD')
      const buques = cargasAnunciadas.filter(carga =>
        moment(carga.fechaDeCarga).format('YYYY-MM-DD') === dateString &&
                (carga.claveCereal.trim() === cerealFiltro || cerealFiltro === 'TODOS'))
      setBuquesFiltrados(buques)
    }
  }, [fechaFiltro, cerealFiltro, cargasAnunciadas, setBuquesFiltrados])

  return (
    <>
      {buquesFiltrados.length > 0 &&
        <div className='selected-day-info'>
          {buquesFiltrados && buquesFiltrados.length > 0 &&
          <>
            <h3>
              {fechaFiltro}
            </h3>
            <ListadoBuquesCalendario buques={buquesFiltrados} obtenerEstimacionSemanal={obtenerEstimacionSemanal} />
          </>
          }
        </div>
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  fechaFiltro: state.buque.fechaCargaFiltro,
  cerealFiltro: state.stock.cerealEstimacionStock,
  availableCereals: state.buque.cargasAnunciadasCereales,
  cargasAnunciadas: state.buque.cargasAnunciadas
})

const mapActionsToProps = {
  obtenerEstimacionSemanal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleBuquesPorDia)
